import addYears from 'date-fns/addYears'

export function setCookie(cookie: string) {
  const config = useRuntimeConfig()
  const newCookie = useCookie(cookie, {
    expires: addYears(new Date(), 2),
    path: '/',
    domain: !process.dev ? `.${config.public.domain}` : '',
  })
  newCookie.value = '1'
}

export function removeCookie(cookie: string) {
  const newCookie = useCookie(cookie)
  newCookie.value = null
}
